module.exports = "<div id=photo-and-name><div class=content><div class=photo><img src=" + require("../assets/photo.jpg") + " width=112 height=112></div><div class=job-title>Front-end Web Developer<br>Senior Associate @ Garena</div><div class=name>Zhang Jianfei</div></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotoAndName.vue
 ** module id = 223
 ** module chunks = 0
 **/